import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";

const PrivateRoute = (props) => {
  const userLogin = useSelector((state) => state.user.userLogin);

  const navigate = useNavigate();

  const allowedRoles = ["admin", "staff", "manager"];

  if (userLogin && allowedRoles.includes(userLogin.role)) {
    return props.element;
  } else {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Xin lỗi, bạn không được phép truy cập trang này."
        extra={
          <Button onClick={() => navigate("/admin/login", { replace: true })}>
            Đi đến trang đăng nhập
          </Button>
        }
      />
    );
  }
};

export default PrivateRoute;
